import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import "../../style.css";
import { ChartBar } from "./chart";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";

export interface Routes {
  data: {
    delays: {
      delay: number;
      region: string;
    }[];
  };
}

export const ChartRegionAvg = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);

  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    delays: [{ delay: 0, region: "" }],
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/routes/delays?graphic_id=chartRegionAvg&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/routes/delays?graphic_id=chartRegionAvg&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: Routes) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="chart-region-avg" className="h100">
      <ChartBar data={routes} />
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
